import { useQuery } from '@tanstack/react-query';
import { GatheringRequests } from 'src/requests/gathering';
import { QueryKey } from 'src/utils/react-query';

export const useGatheringRoomInfoQuery = ({
  externalLink,
}: { externalLink: string }) => {
  const { data: gathering, isLoading: isGatheringLoading } = useQuery({
    queryKey: [QueryKey.GATHERING, externalLink],
    enabled: !!externalLink,
    queryFn: () => GatheringRequests.getChannelInfoByExternalLink(externalLink),
  });

  return {
    gathering,
    isGatheringLoading,
  };
};
